import type { AuthRepositoryInterface } from '../../domain/interfaces/AuthRepositoryInterface';
import type { ForgotPasswordData } from '@/types';

export class ForgotPasswordUseCase {
  constructor(private readonly authRepository: AuthRepositoryInterface) {}

  async execute(data: ForgotPasswordData): Promise<{ message: string }> {
    return this.authRepository.forgotPassword(data);
  }
}
